import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-input',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './input.component.html',
  styleUrl: './input.component.scss'
})
export class InputComponent {
  @Input() label = '';
  @Input() type = 'text';
  @Input() placeholder = '';
  @Input() messageError = '';
  @Input() messageSuccess = '';
  @Input() disabled = false;
  @Input() required = false;
  @Input() readonly = false;

  @Input() inputval: string = '';
  @Output() inputvalChange = new EventEmitter<string>();

  onInputChange() {
    this.inputvalChange.emit(this.inputval);
  }
}
